import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { Container, Box } from '@mui/material';
import Header from './components/Header';
import Map from './components/Map';
import LoginSignup from './pages/LoginSignup';
import Profile from './pages/Profile';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState("");

  useEffect(() => {
    // Initialize token from local storage
    const savedToken = localStorage.getItem('token');
    if (savedToken) {
      setToken(savedToken);
      setIsLoggedIn(true); // Set logged-in state to true if token exists
    }
  }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <Router>
      <Header isLoggedIn={isLoggedIn} />
      <Box>
        <Routes>
          <Route path="/" element={<Map token={token} />} />
          <Route path="/login" element={<LoginSignup setIsLoggedIn={setIsLoggedIn} setToken={setToken} />} />
          <Route path="/profile" element={<Profile setIsLoggedIn={setIsLoggedIn} token={token} />} />
        </Routes>
      </Box>
    </Router>
  );
}

export default App;